import React, { useEffect, useState } from "react";
import { COLUMNS } from './columns'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import Modal from "../../common/Modal/Modal";
import RecipesForm from "../../forms/RecipesForm/RecipesForm";
import { PencilIcon, TrashIcon, ClipboardListIcon } from '@heroicons/react/outline'
import RecipesService from "../../../services/RecipesService";
import GroceriesService from "../../../services/GroceriesService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Recipes = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [shouldLoad, setShouldLoad] = useState(true)
    const [userData, setUserData] = useState({})
    const [modalTitle, setModalTitle] = useState('')
    const [buttonText, setButtonText] = useState('Dodaj Recept')
    const [recipeData, setRecipeData] = useState(null)
    const [groceriesData, setGroceriesData] = useState(null)
    const [isPreview, setIsPreview] = useState(false)
    const [recipeView, setRecipeView] = useState(null)

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getRecipes();
            getGroceries();
        }
    }, [shouldLoad])

    const getRecipes = () => {
        RecipesService.getRecipes().then((response) => {
            let recipes = response.data.map(x => {
                let values = calculateValues(x.recipeItems);
                let recipe = x;
                recipe.calories = values.calories;
                recipe.proteins = values.proteins;
                recipe.carbohydrates = values.carbohydrates;
                recipe.fats = values.fats;
                return recipe;
            });
            setRecipeData(recipes);
        });
    };

    const getGroceries = () => {
        GroceriesService.getSGroceriesUrl().then((response) => {
            let data = response.data.map((item) => {
                let groceryForSelect = {};
                groceryForSelect.label = item.name;
                groceryForSelect.value = item;
                return groceryForSelect;
            });
            setGroceriesData(data);
        });
    };

    const deleteRecipe = (row) => {
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            setRecipeData(null)
            if (result.isDenied) {
                RecipesService.deleteRecipe(row.original.id).then(() => {
                    setShouldLoad(true)
                });
            }
        })
    }

    const addRecipe = (data, formValues) => {
        if (Object.keys(data).length === 0) {
            RecipesService.addRecipe(formValues).then(() => {
                setShouldLoad(true)
            });
        }
        else {
            RecipesService.updateRecipe(formValues).then(() => {
                setShouldLoad(true)
            });
        }
    }


    const showRecipe = () => {
        return <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium  mb-8'>{recipeView.name}</h3>
            <p>{recipeView.description}</p>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium  mb-4' >Lista namirnica:</h3>
            {recipeView.recipeItems.map(({ ingredient, servingSize }, key) => (
                <div className="flex items-center mt-4 p-2 bg-bluePrimary bg-opacity-10 rounded" key={key}>
                    <span key={key}>{ingredient.name}</span>
                    <div className='relative  ml-auto'>
                        <input disabled placeholder="Measure" value={servingSize} className="input-field w-24 pl-2 pr-5" />
                        <span className='absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-gray-800 '>g</span>
                    </div>
                </div>
            ))}
            {displayValues(recipeView.recipeItems)}
        </>
    };

    const calculateValues = (items) => {
        let values = {
            calories: 0.0,
            carbohydrates: 0.0,
            proteins: 0.0,
            fats: 0.0,
        }

        items.forEach(x => {
            values.calories += Number(x.calories)
            values.carbohydrates += Number(x.ingredient.carbohydrates) * (x.servingSize / 100)
            values.proteins += Number(x.ingredient.proteins) * (x.servingSize / 100)
            values.fats += Number(x.ingredient.fats) * (x.servingSize / 100)
        })

        values = {
            calories: values.calories.toFixed(2),
            carbohydrates: values.carbohydrates.toFixed(2),
            fats: values.fats.toFixed(2),
            proteins: values.proteins.toFixed(2),
        }
        return values;
    };

    const displayValues = (items) => {
        let values = calculateValues(items);
        return <div className="flex flex-wrap -mx-3">

            <div className="w-1/2">
                <span className="flex items-center justify center m-3 px-2 py-1 bg-blueSecondary/50 rounded-full text-xs ">Kalorije: {values.calories}</span>
            </div>
            <div className="w-1/2">

                <span className="flex items-center justify center m-3 px-2 py-1 bg-blueSecondary/50 rounded-full text-xs ">Proteini: {values.proteins}</span>
            </div>
            <div className="w-1/2">

                <span className="flex items-center justify center m-3 px-2 py-1 bg-blueSecondary/50 rounded-full text-xs ">Ugljeni hidrati: {values.carbohydrates}</span>
            </div>
            <div className="w-1/2">

                <span className="flex items-center justify center m-3 px-2 py-1 bg-blueSecondary/50 rounded-full text-xs ">masti: {values.fats}</span>
            </div>
        </div>;
    };

    const openModal = (row) => {
        setUserData(row.original);
        setIsPreview(false);
        setIsOpen(true);
        setModalTitle('Izmeni recept');
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient mr-3" title="Obriši" onClick={() => deleteRecipe(row)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <AddUserButton setIsOpen={setIsOpen} setUserData={setUserData} setModalTitle={setModalTitle} buttonText={buttonText} setIsPreview={setIsPreview} />
            {isOpen &&
                <Modal setIsOpen={setIsOpen} modalContent={!isPreview ?
                    <RecipesForm userData={userData} groceriesData={groceriesData} modalTitle={modalTitle} setIsOpen={setIsOpen} recipeData={recipeData} setRecipeData={setRecipeData} addRecipe={addRecipe} />
                    :
                    showRecipe()
                }
                />}
            {recipeData !== null ?
                <Table openModal={openModal} columnsProp={COLUMNS} dataProp={recipeData} additionalColumn={additionalColumn} setIsOpen={setIsOpen} setUserData={setUserData} setModalTitle={setModalTitle} />
                : null}
        </>
    )

};

export default Recipes;
